import { render, staticRenderFns } from "./RoleFormView.vue?vue&type=template&id=c1b02076&scoped=true&"
import script from "./RoleFormView.vue?vue&type=script&lang=js&"
export * from "./RoleFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b02076",
  null
  
)

export default component.exports